import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Existing Components
import Footer from './components/Footer';
import Header from './components/Header';
import VistaTechInternship2 from './components/Program_page2';
import VistaTechInternship from './components/ProgramsPage';
import Terms from './components/terms-conditions-page';
import StudentRegistrationForm from './form/agency';
import CouponPayment from './form/copayment';
import GroupSessionPaymentForm from './form/GroupSessionPayment';
import HiringRegistrationForm from './form/HiringFormData';
import InternshipForm from './form/intership';
import Jobappication from './form/Jobapplications';
import NoCodeWorkshopRegistrations from './form/new_paymentform';
import NewPaymentRegistrationForm from './form/newpaymentdata';
import PayAfterForm from './form/PayAfterForm';
import NoCodeWorkshopRegistration from './form/payafterplacement_payment';
import VistaTechInternshipRegistration from './form/VistaTechInternshipRegistration';
import About from './pages/About';
import Analyst from './pages/Analyst';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Course from './pages/Course';
import DataAnalyticsMasterclass from './pages/DataAnalyticsMasterclass';
import Enrollment from './pages/Enrollment';
import Home from './pages/Home';
import HRConsulting from './pages/HRConsulting';
import Mentors from './pages/Mentors';
import P2PPay from './pages/P2PPay';
import PathToPlacement from './pages/PathToPlacement';
import ResumeReview from './pages/ResumeReview';
import Services from './pages/Services';
import SuccessStories from './pages/SuccessStories';

// Student Tracker
import { StudentCardProvider } from './tracker/context/StudentCardContext';
import { TrackerProvider } from './tracker/context/TrackerContext';
import AdminComplaints from './tracker/pages/admin/AdminComplaints';
import AdminCrm from './tracker/pages/admin/AdminCrm';
import CrmApp from './tracker/crm/CrmApp';
import CrmLogin from './tracker/crm/CrmLogin';
import TrackerAdminDashboard from './tracker/pages/admin/AdminDashboard';
import AdminEodReports from './tracker/pages/admin/AdminEodReports';
import AdminJobBoard from './tracker/pages/admin/AdminJobBoard';
import AdminMentorPerformance from './tracker/pages/admin/AdminMentorPerformance';
import AdminPaymentTracker from './tracker/pages/admin/AdminPaymentTracker';
import AdminPhaseTracker from './tracker/pages/admin/AdminPhaseTracker';
import AdminRanAway from './tracker/pages/admin/AdminRanAway';
import AdminRevenue from './tracker/pages/admin/AdminRevenue';
import AdminStudentOverview from './tracker/pages/admin/AdminStudentOverview';
import AdminStudentProgress from './tracker/pages/admin/AdminStudentProgress';
import ClassLogEdits from './tracker/pages/admin/ClassLogEdits';
import ClassOverReports from './tracker/pages/admin/ClassOverReports';
import IncentiveMonitor from './tracker/pages/admin/IncentiveMonitor';
import LeaveRequests from './tracker/pages/admin/LeaveRequests';
import ManageMentors from './tracker/pages/admin/ManageMentors';
import ManageSalespeople from './tracker/pages/admin/ManageSalespeople';
import ManageStudents from './tracker/pages/admin/ManageStudents';
import MentorCalendar from './tracker/pages/admin/MentorCalendar';
import PaymentDates from './tracker/pages/admin/PaymentDates';
import Payslips from './tracker/pages/admin/Payslips';
import PlacementTracker from './tracker/pages/admin/PlacementTracker';
import ResumeReviews from './tracker/pages/admin/ResumeReviews';
import AtsResumeAI from './tracker/pages/admin/AtsResumeAI';
import SalesGoals from './tracker/pages/admin/SalesGoals';
import SessionSlots from './tracker/pages/admin/SessionSlots';
import StudentLoginManager from './tracker/pages/admin/StudentLoginManager';
import TaskBoard from './tracker/pages/admin/TaskBoard';
import UnassignedLeads from './tracker/pages/admin/UnassignedLeads';
import AdminLogin from './tracker/pages/AdminLogin';
import CoordinatorClassOver from './tracker/pages/coordinator/CoordinatorClassOver';
import CoordinatorPortions from './tracker/pages/coordinator/CoordinatorPortions';
import CoordinatorTaskStatus from './tracker/pages/coordinator/CoordinatorTaskStatus';
import TaskReviews from './tracker/pages/TaskReviews';
import ReviewCheck from './tracker/pages/ReviewCheck';
import { CoordinatorIncentive, CoordinatorMeetingDashboard, CoordinatorMeetingTimes, CoordinatorMeetings } from './tracker/pages/coordinator/SalesMeetings';
import CoordinatorForm from './tracker/pages/CoordinatorForm';
import EditClassLogs from './tracker/pages/EditClassLogs';
import PlacementJobsPage from './tracker/pages/mentor/PlacementJobsPage';
import P2PStudents from './tracker/pages/mentor/P2PStudents';
import MentorForm from './tracker/pages/MentorForm';
import MentorLogin from './tracker/pages/MentorLogin';
import MentorPhaseTracker from './tracker/pages/MentorPhaseTracker';
import MentorPortions from './tracker/pages/MentorPortions';
import MentorQuickActions from './tracker/pages/MentorQuickActions';
import MentorTaskStatus from './tracker/pages/MentorTaskStatus';
import MyLeave from './tracker/pages/MyLeave';
import MyStudents from './tracker/pages/MyStudents';
import SalesDashboard from './tracker/pages/sales/SalesDashboard';
import SalesLogin from './tracker/pages/sales/SalesLogin';
import SeniorTeamOverview from './tracker/pages/SeniorTeamOverview';
import TimetablePage from './tracker/pages/Timetable';

// Student Portal
import { StudentProvider } from './student/context/StudentContext';
import StudentDashboard from './student/pages/StudentDashboard';
import StudentLogin from './student/pages/StudentLogin';
import StudentSetPassword from './student/pages/StudentSetPassword';

function App() {
  return (
    <BrowserRouter>
      <StudentProvider>
      <TrackerProvider>
      <StudentCardProvider>
        <div className="min-h-screen bg-background font-poppins">
          <Routes>
            {/* Student Tracker Routes — no public Header/Footer */}
            <Route path="/tracker/mentor/login"  element={<MentorLogin />} />
            <Route path="/tracker/admin/login"   element={<AdminLogin />} />
            <Route path="/tracker/mentor/form" element={<MentorForm />} />
            <Route path="/tracker/admin/students"  element={<ManageStudents />} />
            <Route path="/tracker/admin/mentors"   element={<ManageMentors />} />
            <Route path="/tracker/timetable"       element={<TimetablePage />} />
            <Route path="/tracker/mentor/students" element={<MyStudents />} />
            <Route path="/tracker/mentor/portions" element={<MentorPortions />} />
            <Route path="/tracker/mentor/tasks"    element={<MentorTaskStatus />} />
            {/* Students' tasks: review them (mentors; coordinators and the admin see everyone's), and check the reviews */}
            <Route path="/tracker/mentor/reviews"        element={<TaskReviews />} />
            <Route path="/tracker/coordinator/reviews"   element={<TaskReviews />} />
            <Route path="/tracker/admin/task-reviews"    element={<TaskReviews />} />
            <Route path="/tracker/coordinator/review-check" element={<ReviewCheck />} />
            <Route path="/tracker/admin/review-check"    element={<ReviewCheck />} />
            <Route path="/tracker/mentor/phases"   element={<MentorPhaseTracker />} />
            <Route path="/tracker/mentor/team"     element={<SeniorTeamOverview />} />
            <Route path="/tracker/admin/progress"      element={<AdminStudentProgress />} />
            <Route path="/tracker/admin/payments"      element={<AdminPaymentTracker />} />
            <Route path="/tracker/admin/salespeople"   element={<ManageSalespeople />} />
            <Route path="/tracker/admin/incentives"    element={<IncentiveMonitor />} />
            <Route path="/tracker/admin/sales-goals"  element={<SalesGoals />} />
            <Route path="/tracker/admin/unassigned"    element={<UnassignedLeads />} />
            <Route path="/tracker/admin/session-slots" element={<SessionSlots />} />
            <Route path="/tracker/admin/payslips"      element={<Payslips />} />
            <Route path="/tracker/admin/log-edits"     element={<ClassLogEdits />} />
            <Route path="/tracker/admin/leave-requests" element={<LeaveRequests />} />
            <Route path="/tracker/admin/payment-dates"  element={<PaymentDates />} />
            <Route path="/tracker/admin/class-over"     element={<ClassOverReports />} />
            <Route path="/tracker/mentor/edit-logs"      element={<EditClassLogs />} />
            <Route path="/tracker/coordinator/edit-logs" element={<EditClassLogs />} />
            <Route path="/tracker/mentor/leave"          element={<MyLeave />} />
            <Route path="/tracker/coordinator/leave"     element={<MyLeave />} />
            <Route path="/tracker/admin/overview"        element={<AdminStudentOverview />} />
            <Route path="/tracker/admin/phases"         element={<AdminPhaseTracker />} />
            <Route path="/tracker/admin/complaints"     element={<AdminComplaints />} />
            <Route path="/tracker/admin/jobs"           element={<AdminJobBoard />} />
            <Route path="/tracker/admin/resume-reviews" element={<ResumeReviews />} />
            <Route path="/tracker/admin/ats-resume" element={<AtsResumeAI />} />
            <Route path="/tracker/admin/eod-reports"  element={<AdminEodReports />} />
            <Route path="/tracker/admin/dashboard"      element={<TrackerAdminDashboard />} />
            <Route path="/tracker/admin/mentor-perf"    element={<AdminMentorPerformance />} />
            <Route path="/tracker/admin/revenue"        element={<AdminRevenue />} />
            <Route path="/tracker/admin/ran-away"       element={<AdminRanAway />} />
            <Route path="/tracker/admin/tasks"          element={<TaskBoard />} />
            <Route path="/tracker/admin/attendance"     element={<MentorCalendar />} />
            <Route path="/tracker/mentor/quick-actions" element={<MentorQuickActions />} />
            <Route path="/tracker/mentor/jobs"          element={<PlacementJobsPage />} />
            <Route path="/tracker/mentor/p2p"           element={<P2PStudents />} />
            <Route path="/tracker/admin/student-login" element={<StudentLoginManager />} />
            <Route path="/tracker/coordinator/student-login" element={<StudentLoginManager />} />
            <Route path="/tracker/coordinator/form"    element={<CoordinatorForm />} />
            <Route path="/tracker/coordinator/phases"  element={<AdminPhaseTracker />} />
            <Route path="/tracker/coordinator/complaints" element={<AdminComplaints />} />
            <Route path="/tracker/coordinator/portions"  element={<CoordinatorPortions />} />
            <Route path="/tracker/coordinator/tasks"    element={<CoordinatorTaskStatus />} />
            <Route path="/tracker/coordinator/class-over" element={<CoordinatorClassOver />} />
            {/* A Student Coordinator's sales meetings (server/routes/crmMeetings.js) */}
            <Route path="/tracker/coordinator/meetings"          element={<CoordinatorMeetings />} />
            <Route path="/tracker/coordinator/meeting-times"     element={<CoordinatorMeetingTimes />} />
            <Route path="/tracker/coordinator/meeting-dashboard" element={<CoordinatorMeetingDashboard />} />
            <Route path="/tracker/coordinator/incentive"         element={<CoordinatorIncentive />} />
            <Route path="/tracker/admin/placement"     element={<PlacementTracker />} />
            <Route path="/tracker/admin/crm"        element={<AdminCrm />} />
            <Route path="/tracker/admin/crm/:tab"   element={<AdminCrm />} />
            {/* Sales CRM site — its own sign-in and menu */}
            <Route path="/crm/login"               element={<CrmLogin />} />
            <Route path="/crm"                     element={<CrmApp />} />
            <Route path="/crm/:page"               element={<CrmApp />} />
            <Route path="/tracker/sales/login"     element={<SalesLogin />} />
            <Route path="/tracker/sales/dashboard" element={<SalesDashboard />} />
            <Route path="/tracker" element={<Navigate to="/tracker/mentor/login" replace />} />

            {/* Student Portal — no Header/Footer */}
            <Route path="/student/login"        element={<StudentLogin />} />
            <Route path="/student/set-password" element={<StudentSetPassword />} />
            <Route path="/student/dashboard"    element={<StudentDashboard />} />
            <Route path="/student" element={<Navigate to="/student/login" replace />} />

            {/* Standalone Landing Pages — no Header/Footer */}
            <Route path="/data-analytics-masterclass" element={<DataAnalyticsMasterclass />} />
            <Route path="/analyst" element={<Analyst />} />
            <Route path="/mentors" element={<Mentors />} />
            <Route path="/enroll" element={<Enrollment />} />
            <Route path="/p2p" element={<PathToPlacement />} />
            <Route path="/p2p/pay" element={<P2PPay />} />
            <Route path="/path-to-placement" element={<Navigate to="/p2p" replace />} />

            {/* Main Website Routes - With Header/Footer */}
            <Route
              path="*"
              element={
                <>
                  <Header />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/Job-application" element={<Jobappication />} />
                    <Route path="/Vista-Tech-Internship" element={<VistaTechInternship />} />
                    <Route path="/VistaTech-Internship" element={<VistaTechInternship2 />} />
                    <Route path="/Pay-After-Placement-Payment-Form" element={<NoCodeWorkshopRegistration />} />
                    <Route path="/Pay-After-Placement-PaymentForm" element={<NoCodeWorkshopRegistrations />} />
                    <Route path="/Pay-After-Placement-Group" element={<GroupSessionPaymentForm />} />
                    <Route path="/Pay-After-Placement" element={<StudentRegistrationForm />} />
                    <Route path="/Pay-After-Placement-New" element={<NewPaymentRegistrationForm />} />
                    <Route path="/internship-form" element={<VistaTechInternshipRegistration />} />
                    <Route path="/PayAfterForm" element={<PayAfterForm />} />
                    <Route path="/courses" element={<Course />} />
                    <Route path="/Terms-and-Conditions" element={<Terms />} />
                    <Route path="/hiring-form" element={<HiringRegistrationForm />} />
                    <Route path="/internship-registration" element={<InternshipForm />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/success-stories" element={<SuccessStories />} />
                    <Route path="/contact" element={<Contact />} />
                    {/* The education landing page was removed — its links go to the courses page */}
                    <Route path="/education" element={<Navigate to="/courses" replace />} />
                    {/* Digital marketing is no longer offered — old links go home */}
                    <Route path="/digital-marketing" element={<Navigate to="/" replace />} />
                    <Route path="/dm-enquiry" element={<Navigate to="/" replace />} />
                    <Route path="/hr-consulting" element={<HRConsulting />} />
                    <Route path="/resume-review" element={<ResumeReview />} />
                    <Route path="/coupon-payment" element={<CouponPayment />} />
                  </Routes>
                  <Footer />
                </>
              }
            />
          </Routes>

          {/* Toast Notifications */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </StudentCardProvider>
      </TrackerProvider>
      </StudentProvider>
    </BrowserRouter>
  );
}

export default App;